import { render, staticRenderFns } from "./select-plan.vue?vue&type=template&id=1f0c642a&"
import script from "./select-plan.vue?vue&type=script&lang=js&"
export * from "./select-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports